export function isScrolledToBottom(
  element: {
    scrollHeight: number
    offsetHeight: number
    scrollTop: number
  },
  { tolerance = 1 }: { tolerance?: number } = {},
): boolean {
  return (
    Math.abs(element.scrollHeight - element.offsetHeight - element.scrollTop) <=
    tolerance
  )
}
